// src/pages/Testimonials.tsx
import React from 'react';

import SEO from "../components/SEO";
import { seoConfig } from "../seoConfig";

import GetInTouch from '../components/GetInTouch';

const Testimonials: React.FC = () => {

const seo = seoConfig.testimonials; // ✅ Load meta for this page


  return (



<>


      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url={seo.url}
        image={seo.image}
      />


  {/* rts bread crumba rea start */}
  <div className="rts-breadcrumb-area-testimonial bg_image">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="baread-crumb-main-wrapper pt--100">
            <div className="inner">
              <h1 className="title rts_hero__title">Testimonials</h1>
              <span className="bg-text d-none d-md-inline">Manikarn Digital</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* rts bread crumba rea end */}





    {/* rts case studyes area start */}
  <div className="rts-portfolio-grid-area column pb--40">
    <div className="container-140">
      <div className="row g-0 separetor-portfolio-bottom pl--10 pr--10">


{/* single portfolio area start */}
        <div className="col-lg-4 col-md-6 col-sm-12 col-12">


{/* ==== Testimonial Start ==== */}
      <div className="testimonial-scroll-item signle-portfolio-style-four-inner mb--30">
        <div className="projects-s__single topy-tilt">


  <div className="single-testimonials-main-wrapper testimonial-bg">
    <div className="star-area-start">
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
    </div>
    <div className="body">
      <p className="disc">
        &quot;Manikarn Digital completely revamped our outdated website into a modern, user-friendly platform. Their design and development team was professional, responsive, and truly brought our brand vision to life.&quot;
      </p>
      <div className="author-area">
        <div className="info-wrapper">
          <h6 className="title">Emily Carter – USA</h6>
        </div>
      </div>
    </div>
  </div>



        </div>
      </div>

{/* ==== Testimonial End ==== */}


{/* ==== Testimonial Start ==== */}
      <div className="testimonial-scroll-item signle-portfolio-style-four-inner mb--30">
        <div className="projects-s__single topy-tilt">


  <div className="single-testimonials-main-wrapper testimonial-bg">
    <div className="star-area-start">
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
    </div>
    <div className="body">
      <p className="disc">
        &quot;Thanks to Manikarn Digital&apos;s strategic digital marketing services, we&apos;ve seen a noticeable increase in website traffic and customer engagement. Their SEO and social media efforts are incredibly effective.&quot;
      </p>
      <div className="author-area">
        <div className="info-wrapper">
          <h6 className="title">Arjun Mehta – India</h6>
        </div>
      </div>
    </div>
  </div>



        </div>
      </div>

{/* ==== Testimonial End ==== */}



{/* ==== Testimonial Start ==== */}
      <div className="testimonial-scroll-item signle-portfolio-style-four-inner mb--30">
        <div className="projects-s__single topy-tilt">


  <div className="single-testimonials-main-wrapper testimonial-bg">
    <div className="star-area-start">
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
    </div>
    <div className="body">
      <p className="disc">
        &quot;We hired Manikarn Digital for graphic designing, and the results were fantastic. Their creativity, attention to detail, and understanding of brand identity exceeded all our expectations. Highly recommended!&quot;
      </p>
      <div className="author-area">
        <div className="info-wrapper">
          <h6 className="title">Sarah Jensen – Australia</h6>
        </div>
      </div>
    </div>
  </div>



        </div>
      </div>

{/* ==== Testimonial End ==== */}




        </div>
{/* single portfolio area end */}







{/* single portfolio area start */}
        <div className="col-lg-4 col-md-6 col-sm-12 col-12">





{/* ==== Testimonial Start ==== */}
      <div className="testimonial-scroll-item signle-portfolio-style-four-inner mb--30">
        <div className="projects-s__single topy-tilt">


  <div className="single-testimonials-main-wrapper testimonial-bg">
    <div className="star-area-start">
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
    </div>
    <div className="body">
      <p className="disc">
        &quot;I&apos;ve worked with several agencies before, but Manikarn&apos;s support team truly stands out. They&apos;re quick, friendly, and always solve issues before they become real problems. Exceptional service!&quot;
      </p>
      <div className="author-area">
        <div className="info-wrapper">
          <h6 className="title">Daniel Kowalski – Poland</h6>
        </div>
      </div>
    </div>
  </div>



        </div>
      </div>

{/* ==== Testimonial End ==== */}






{/* ==== Testimonial Start ==== */}
      <div className="testimonial-scroll-item signle-portfolio-style-four-inner mb--30">
        <div className="projects-s__single topy-tilt">


  <div className="single-testimonials-main-wrapper testimonial-bg">
    <div className="star-area-start">
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
    </div>
    <div className="body">
      <p className="disc">
        &quot;With their website care plan, we never worry about updates, backups, or performance. The Manikarn team handles everything proactively, allowing us to focus on growing our business.&quot;
      </p>
      <div className="author-area">
        <div className="info-wrapper">
          <h6 className="title">Fatima Al-Mansoori – Qatar</h6>
        </div>
      </div>
    </div>
  </div>



        </div>
      </div>

{/* ==== Testimonial End ==== */}






{/* ==== Testimonial Start ==== */}
      <div className="testimonial-scroll-item signle-portfolio-style-four-inner mb--30">
        <div className="projects-s__single topy-tilt">


  <div className="single-testimonials-main-wrapper testimonial-bg">
    <div className="star-area-start">
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
    </div>
    <div className="body">
      <p className="disc">
        &quot;Manikarn Digital&apos;s graphic design services helped elevate our brand image. The visuals they delivered were professional, eye-catching, and perfectly aligned with our marketing goals. We&apos;ll definitely work with them again!&quot;
      </p>
      <div className="author-area">
        <div className="info-wrapper">
          <h6 className="title">Lucas Martins – Brazil</h6>
        </div>
      </div>
    </div>
  </div>



        </div>
      </div>

{/* ==== Testimonial End ==== */}











        </div>
{/* single portfolio area end */}











{/* single portfolio area start */}
        <div className="col-lg-4 col-md-6 col-sm-12 col-12">









{/* ==== Testimonial Start ==== */}
      <div className="testimonial-scroll-item signle-portfolio-style-four-inner mb--30">
        <div className="projects-s__single topy-tilt">


  <div className="single-testimonials-main-wrapper testimonial-bg">
    <div className="star-area-start">
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
    </div>
    <div className="body">
      <p className="disc">
        &quot;With Manikarn&apos;s website care services, our site remains updated, secure, and running smoothly. It&apos;s like having an in-house tech team, but more affordable and incredibly dependable.&quot;
      </p>
      <div className="author-area">
        <div className="info-wrapper">
          <h6 className="title">Jonathan Kim – South Korea</h6>
        </div>
      </div>
    </div>
  </div>



        </div>
      </div>

{/* ==== Testimonial End ==== */}



{/* ==== Testimonial Start ==== */}
      <div className="testimonial-scroll-item signle-portfolio-style-four-inner mb--30">
        <div className="projects-s__single topy-tilt">


  <div className="single-testimonials-main-wrapper testimonial-bg">
    <div className="star-area-start">
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
    </div>
    <div className="body">
      <p className="disc">
        &quot;We migrated to Manikarn&apos;s hosting and support services, and the experience has been flawless. Their fast servers and responsive support team make website management stress-free and efficient.&quot;
      </p>
      <div className="author-area">
        <div className="info-wrapper">
          <h6 className="title">Priya Nair – UAE</h6>
        </div>
      </div>
    </div>
  </div>



        </div>
      </div>

{/* ==== Testimonial End ==== */}




{/* ==== Testimonial Start ==== */}
      <div className="testimonial-scroll-item signle-portfolio-style-four-inner mb--30">
        <div className="projects-s__single topy-tilt">


  <div className="single-testimonials-main-wrapper testimonial-bg">
    <div className="star-area-start">
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
    </div>
    <div className="body">
      <p className="disc">
        &quot;Manikarn Digital delivered a fully customized website ahead of schedule. Their development process was smooth, and they were very responsive to feedback. A reliable partner for any web project.&quot;
      </p>
      <div className="author-area">
        <div className="info-wrapper">
          <h6 className="title">Michael Thompson – UK</h6>
        </div>
      </div>
    </div>
  </div>



        </div>
      </div>

{/* ==== Testimonial End ==== */}






        </div>
{/* single portfolio area end */}










      </div>
    </div>
  </div>
  {/* rts case studyes area end */}





{/* ==== GetInTouch Section start ==== */}
<GetInTouch />
{/* ==== / GetInTouch Section end ==== */}  



</>    


  );
};

export default Testimonials;
